function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/display-name
const Heading = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    className = '',
    children,
    size,
    level = 2,
    fontFamily,
    color = '',
    style = {},
    ...restProps
  } = props;
  const HeadingTag = `h${level}`;
  const defaultSizes = {
    1: 'lg',
    2: 'md',
    3: 'sm',
    4: 'xs',
    5: 'xs',
    6: 'xs'
  };
  const fontFamilyVariant = fontFamily || (level === 1 ? 'primary' : 'secondary_interactive');
  const headingSize = size || defaultSizes[level];
  const headingClasses = classNames({
    [className]: !!className,
    [`sib-typo_heading--${fontFamilyVariant}`]: !!fontFamilyVariant,
    [`sib-typo_heading-size--${headingSize}`]: !!headingSize
  });
  const headingColor = color || 'var(--sib-color_content-primary,#1f2d3d)';
  return /*#__PURE__*/React.createElement(HeadingTag, _extends({
    className: headingClasses,
    ref: ref
  }, restProps, {
    style: {
      color: headingColor,
      ...style
    }
  }), children);
});
Heading.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  level: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
  fontFamily: PropTypes.oneOf(['primary', 'secondary_interactive', 'secondary_regular', 'secondary_bold']),
  color: PropTypes.string,
  style: PropTypes.object
};
export default Heading;